document.addEventListener('DOMContentLoaded', function () {
  const bar = document.querySelector('.announcement-bar');
  if (!bar || bar.dataset.slide !== 'true') return;

  const marquee = bar.querySelector('.banner-container');
  if (!marquee) return;

  if (window.innerWidth <= 1024) {
    // Mobile : défilement marquee continu
    const speed = 1.5;
    let x = bar.offsetWidth;

    (function animate() {
      x -= speed;
      if (x < -marquee.offsetWidth) x = bar.offsetWidth;
      marquee.style.transform = `translateX(${x}px)`;
      requestAnimationFrame(animate);
    })();
  } else {
    // Desktop : carousel avec pause au survol
    const messages = bar.querySelectorAll('.banner-message');
    if (messages.length < 2) return;

    let index = 0;
    let interval;

    function changeMessage() {
      messages[index].classList.remove('active');
      index = (index + 1) % messages.length;
      messages[index].classList.add('active');
    }

    function start() { interval = setInterval(changeMessage, 4000); }
    function stop() { clearInterval(interval); }

    start();
    marquee.addEventListener('mouseenter', stop);
    marquee.addEventListener('mouseleave', start);
  }
});
